import { IOfferQuestCondition } from "./IOfferQuestCondition";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 13:44
 */

export class OfferQuestConditionInteger implements IOfferQuestCondition {
    protected static TYPE_BETWEEN: string = "Between";
    protected static TYPE_MAX: string = "Max";
    protected static TYPE_MIN: string = "Min";
    protected static TYPE_EQUALS: string = "Equals";

    protected _params: any;
    protected _currentProgressValue: number = 0;
    protected _id: string;

    constructor(id: string, params: any) {
        this._id = id;
        this._params = params;
        this._currentProgressValue = 0;
    }

    public get registerName(): string {
        return "OfferQuestConditionInteger";
    }

    public parseFromObjectParam(id: string, params: any): void {
        this._id = id;
        this._params = params;
        this._currentProgressValue = 0;
    }

    public get conditionPassed(): boolean {
        switch (this._id.substring(this.registerName.length)) {
            case OfferQuestConditionInteger.TYPE_BETWEEN:
                let minPassed: boolean = false;
                if (this._params.minInclusive == null || this._params.minInclusive == true)	// is not set or is set to true
                {
                    minPassed = this._currentProgressValue >= parseInt(this._params.min);
                }
                else {
                    minPassed = this._currentProgressValue > parseInt(this._params.min);
                }

                let maxPassed: boolean = false;
                if (this._params.maxInclusive == null || this._params.maxInclusive == true) {
                    maxPassed = this._currentProgressValue <= parseInt(this._params.max);
                }
                else {
                    maxPassed = this._currentProgressValue < parseInt(this._params.max);
                }

                return minPassed && maxPassed;

            case OfferQuestConditionInteger.TYPE_MAX:
                if (this._params.inclusive)	// is set and set to true
                {
                    return this._currentProgressValue <= parseInt(this._params.value);
                }
                else {
                    return this._currentProgressValue < parseInt(this._params.value);
                }

            case OfferQuestConditionInteger.TYPE_MIN:
                if (this._params.inclusive)	// is set and set to true
                {
                    return this._currentProgressValue >= parseInt(this._params.value);
                }
                else {
                    return this._currentProgressValue > parseInt(this._params.value);
                }

            case OfferQuestConditionInteger.TYPE_EQUALS:
                return this._currentProgressValue == parseInt(this._params.value);

            default:
                return false;
        }
    }

    public get currentProgressValue(): number {
        return this._currentProgressValue;
    }

    public set currentProgressValue(value: number) {
        this._currentProgressValue = value;
    }

    public get conditionTextId(): string {
        return "offer_questcondition_" + this._id;
    }

    public get conditionTextReplacements(): any[] {
        switch (this._id.substring(this.registerName.length)) {
            case OfferQuestConditionInteger.TYPE_BETWEEN:
                return [parseInt(this._params.min), parseInt(this._params.max), this._currentProgressValue];

            case OfferQuestConditionInteger.TYPE_MAX:
                if (this._params.inclusive)	// is set and set to true
                {
                    return [parseInt(this._params.value) + 1, this._currentProgressValue];
                }
                else {
                    return [parseInt(this._params.value), this._currentProgressValue];
                }

            case OfferQuestConditionInteger.TYPE_MIN:
                if (this._params.inclusive)	// is set and set to true
                {
                    return [parseInt(this._params.value), this._currentProgressValue];
                }
                else {
                    return [parseInt(this._params.value) + 1, this._currentProgressValue];
                }

            case OfferQuestConditionInteger.TYPE_EQUALS:
                return [parseInt(this._params.value), this._currentProgressValue];

            default:
                return [];
        }
    }

    public dispose(): void {
        this._params = null;
        this._id = null;
    }
}

